var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2IconHealthV5(_ref, svgRef) {
  var _ref2, _ref3;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3924 6.05817C10.482 6.31411 9.51829 6.31411 8.60791 6.05817",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0713 5.34363V5.34363C15.11 3.7413 13.1951 2.98015 11.396 3.48619L10.6007 3.70962C10.208 3.81966 9.79283 3.81966 9.401 3.70962L8.60567 3.48619C6.80575 2.98015 4.89162 3.7413 3.92955 5.34363V5.34363C3.54189 5.98974 3.3368 6.72921 3.33595 7.48369V7.56122C3.33263 10.124 3.84868 12.6608 4.8516 15.0193L5.12505 15.6613C5.38516 16.2724 5.98624 16.67 6.65152 16.67V16.67C7.33097 16.67 7.94206 16.2548 8.19299 15.6237L8.98416 13.6313C9.15006 13.2127 9.55273 12.9385 10.0004 12.9385V12.9385C10.4481 12.9385 10.8508 13.2127 11.0167 13.6313L11.8078 15.6237C12.0588 16.2548 12.6699 16.67 13.3493 16.67V16.67C14.0146 16.67 14.6157 16.2724 14.8758 15.6604L15.1492 15.0185C16.153 12.66 16.6682 10.1231 16.6649 7.56039V7.48286C16.664 6.72921 16.4589 5.98974 16.0713 5.34363Z",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2IconHealthV5);
export default __webpack_public_path__ + "static/media/customV2IconHealthV5.e843a81aa19eef4a34b8065d31147e0f.svg";
export { ForwardRef as ReactComponent };